import { useState } from "react";

const BTGlobal = () => {
    const [btGridRef, setBtGridRef] = useState<React.MutableRefObject<any>>();
    return {
        btGridRef,setBtGridRef
    }
}
export {BTGlobal}